import{a as e}from"./chunk-EI7MMDWY.js";var o=e(a=>(1-Math.cos(a))/2,"haversine"),s=e(a=>Math.acos(1-2*a),"archaversine");export{o as a,s as b};
